import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export type ShipperEmailNotificationPreferenceKey =
  "SHIPMENT_BOOKED" | "SHIPMENT_SHARED" | "MICRO_REVIEW_REMINDER";

export interface ShipperEmailNotificationPreference {
  preference_key: ShipperEmailNotificationPreferenceKey;
  email_enabled: boolean;
}

interface ShipperEmailNotificationPreferencesResponse {
  results: ShipperEmailNotificationPreference[];
}

export function useShipperEmailNotificationPreferences() {
  const { role } = useRoleContext();

  const url =
    role?.type === "SHIPPER" ? "/shipper-email-notification-preferences" : null;

  const { data, loading, error, refetch } =
    useSwrFetch<ShipperEmailNotificationPreferencesResponse>({
      url,
      errorMessage: "Failed to fetch email notification preferences",
      errorMessageKey: "message",
    });

  return {
    preferences: data?.results ?? null,
    loading,
    error,
    refetch,
  };
}
